import Vue from "vue";
import Router from "vue-router";
import FullDtlInfo from "./views/full/DetailInfo.vue";
// import FullTmSearch from "./views/full/TmSearch.vue";
// import FullFooter from "./views/full/FullFooter.vue";
import FullInfo from "./views/full/Info.vue";
// import FullRwDetail from "./views/full/RiverwarnDetail.vue";
// import FullRwList from "./views/full/RiverwarnList.vue";
import FullTmDetail from "./views/full/TmDetail.vue";
import FullTmOvList from "./views/full/TmOvList.vue";
import FullTwCheck from "./views/full/TwitterCheck.vue";
import MbDtlInfo from "./views/mb/dlgs/DetailInfo.vue";
import MbInfo from "./views/mb/dlgs/Info.vue";
import MbIudation from "./views/mb/dlgs/Inundation.vue";
import MbRadar from "./views/mb/dlgs/Radar.vue";
import MbRegistPoint from "./views/mb/dlgs/RegistPoint.vue";
import MbRwDetail from "./views/mb/dlgs/RiverwarnDetail.vue";
import MbRwList from "./views/mb/dlgs/RiverwarnList.vue";
import MbTmList from "./views/mb/dlgs/TmList.vue";
import MbTmObs from "./views/mb/dlgs/TmObs.vue";
import MbVc from "./views/mb/dlgs/Viewconfig.vue";
import MbHeader from "./views/mb/Header.vue";
// import PcFooter from "./views/pc/Footer.vue";
import PcHeader from "./views/pc/Header.vue";
import PcPanel from "./views/pc/Panel.vue";
import Administrator from "./views/pc/panels/Administrator.vue";
import Inundation from "./views/pc/panels/Inundation.vue";
import Overview from "./views/pc/panels/Overview.vue";
import Radar from "./views/pc/panels/Radar.vue";
import RegistPoint from "./views/pc/panels/RegistPoint.vue";
import Riverwarn from "./views/pc/panels/Riverwarn.vue";
import RiverwarnList from "./views/pc/panels/RiverwarnList.vue";
import TmList from "./views/pc/panels/TmList.vue";
import TmObs from "./views/pc/panels/TmObs.vue";
import Viewconfig from "./views/pc/panels/Viewconfig.vue";
import RpDlg from "./views/rp/RegistPointDlg.vue";
import RpHeader from "./views/rp/Header.vue";
import PrintHeader from "./views/full/PrintHeader.vue";
import PrintPreview from "./views/full/PrintPreviewDetail.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: PcHeader,
        panel: PcPanel,
      },
    },
    {
      path: "/pc",
      name: "home2",
      components: {
        header: PcHeader,
        panel: PcPanel,
      },
      children: [
        {
          path: "ov",
          components: {
            contents: Overview,
          },
        },
        {
          path: "tmlist",
          components: {
            contents: TmList,
          },
        },
        {
          path: "tm",
          components: {
            contents: TmObs,
          },
        },
        {
          path: "rwlist",
          components: {
            contents: RiverwarnList,
          },
        },
        {
          path: "rw",
          components: {
            contents: Riverwarn,
          },
        },
        {
          path: "rp",
          components: {
            contents: RegistPoint,
          },
        },
        {
          path: "rd",
          components: {
            contents: Radar,
          },
        },
        {
          path: "iu",
          components: {
            contents: Inundation,
          },
        },
        {
          path: "vc",
          components: {
            contents: Viewconfig,
          },
        },
        {
          path: "ad",
          components: {
            contents: Administrator,
          },
        },
      ],
    },
    {
      path: "/pcfull/info",
      name: "info",
      components: {
        header: PcHeader,
        fullContents: FullInfo,
      },
    },
    {
      path: "/pcfull/info/detail",
      name: "dtlinfo",
      components: {
        header: PcHeader,
        fullContents: FullDtlInfo,
      },
    },
    {
      path: "/pcfull/ovlist",
      name: "ovlist",
      components: {
        header: PcHeader,
        fullContents: FullTmOvList,
      },
    },
    {
      path: "/pcfull/tm",
      name: "tm",
      components: {
        header: PcHeader,
        fullContents: FullTmDetail,
      },
    },
    {
      path: "/twitterCheck",
      name: "twitterCheck",
      components: {
        header: PcHeader,
        fullContents: FullTwCheck,
      },
    },
    {
      path: "/printPreview",
      name: "printPreview",
      components: {
        header: PrintHeader,
        fullContents: PrintPreview,
      },
    },
    {
      path: "/mb",
      name: "home3",
      components: {
        header: MbHeader,
      },
    },
    {
      path: "/mb/tm",
      name: "mbtm",
      components: {
        header: MbHeader,
        dlg: MbTmObs,
      },
    },
    {
      path: "/mb/tmlist",
      name: "tmlist",
      components: {
        header: MbHeader,
        dlg: MbTmList,
      },
    },
    {
      path: "/mb/rp",
      name: "rp",
      components: {
        header: MbHeader,
        dlg: MbRegistPoint,
      },
    },
    {
      path: "/mb/rwlist",
      name: "mbrwlist",
      components: {
        header: MbHeader,
        dlg: MbRwList,
      },
    },
    {
      path: "/mb/rwdetail",
      name: "mbrwdetail",
      components: {
        header: MbHeader,
        dlg: MbRwDetail,
      },
    },
    {
      path: "/mb/rd",
      name: "rd",
      components: {
        header: MbHeader,
        dlg: MbRadar,
      },
    },
    {
      path: "/mb/iu",
      name: "iu",
      components: {
        header: MbHeader,
        dlg: MbIudation,
      },
    },
    {
      path: "/mb/info",
      name: "mbinfo",
      components: {
        header: MbHeader,
        dlg: MbInfo,
      },
    },
    {
      path: "/mb/info/detail",
      name: "mbdtlinfo",
      components: {
        header: MbHeader,
        dlg: MbDtlInfo,
      },
    },
    {
      path: "/mb/vc",
      name: "mbvc",
      components: {
        header: MbHeader,
        dlg: MbVc,
      },
    },
    {
      path: "/rp",
      name: "rp",
      components: {
        header: RpHeader,
        dlg: RpDlg,
      },
    },
    {
      path: "/pc/*",
      redirect: "pc",
    },
    {
      path: "/pcfull/*",
      redirect: "pc",
    },
    {
      path: "/mb/*",
      redirect: "mb",
    },
    {
      path: "/*",
      redirect: "/",
    },
  ],
});
